import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentOfficeSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type agentOfficeHistoryProps = {
	historyKey: string;
	fetchData: {
		page: number;
	};
	id: number | string;
};

const useGetAgentOfficeHistoryQuery = ({
	historyKey,
	fetchData,
	id,
}: agentOfficeHistoryProps) => {
	const dispatch = useDispatch();

	const { page } = fetchData || {};

	return useQuery(
		[historyKey, page],
		() => agentOfficeSetupService.getAgentOfficeHistory({ page, id }),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!id,
			cacheTime: 0,
		},
	);
};

export default useGetAgentOfficeHistoryQuery;
